import styled from "styled-components";
const EditStyles = styled.div`
  .wrapper img {
    max-width: 100%;
  }
`;
export default EditStyles;



// WEBPACK FOOTER //
// ./src/Components/EditPost/EditStyles.js